export default __webpack_public_path__ + "static/media/bannerLunarMb.5f04a85d.png";